import { render, staticRenderFns } from "./producto_screen.vue?vue&type=template&id=dc8b7446&scoped=true"
import script from "./producto_screen.vue?vue&type=script&lang=js"
export * from "./producto_screen.vue?vue&type=script&lang=js"
import style0 from "./producto_screen.vue?vue&type=style&index=0&id=dc8b7446&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc8b7446",
  null
  
)

export default component.exports